import React from 'react'
import { AgChartsReact as AgCharts } from 'ag-charts-react'
import CustomLegend from './components/CustomLegend'
import Simple from './configs/Simple'
import Stacked from './configs/Stacked'
import Grouped from './configs/Grouped'

import './index.scss'

const getOptions = ({ type, config }) => {
  switch (type) {
    case 'SIMPLE':
      return Simple(config)
    case 'STACKED':
      return Stacked(config)
    case 'GROUPED':
      return Grouped(config)
    default:
      return Simple(config)
  }
}

function AgChartsBuilder({ type, config }) {
  const { customGroupLegend, data } = config
  return (
    <div className='agchart-wrapper'>
      <AgCharts options={getOptions({ type, config })} />
      {customGroupLegend && <CustomLegend data={data} />}
    </div>
  )
}

export default AgChartsBuilder
